import {
  GridColDef,
  GridValidRowModel,
  getGridStringOperators,
} from '@mui/x-data-grid-pro';
import { ComparisonOperatorEnum } from '@src/types/ComparisonOperators';

export default function generateArchiveColumns(
  _handleDetailsClick: (gridRow: GridValidRowModel) => () => void,
): GridColDef[] {
  const stringFilterOperator = {
    operators: getGridStringOperators().filter(
      (operator) => operator.value === ComparisonOperatorEnum.EQUALS,
    ),
  };

  const ArchiveGridColumns: GridColDef[] = [];

  const idColumn: GridColDef = {
    field: '_id',
    headerName: 'ID',
    width: 100,
    flex: 1,
    filterOperators: stringFilterOperator.operators,
    valueGetter: (_value, row) => {
      return row._id?.$oid?.slice(-8) || 'N/A';
    },
  };

  const topicColumn: GridColDef = {
    field: 'topic',
    headerName: 'Topic',
    filterOperators: stringFilterOperator.operators,
  };

  const siteIDColumn: GridColDef = {
    field: 'siteId',
    headerName: 'Site ID',
    filterOperators: stringFilterOperator.operators,
  };

  const parentDeviceTypeColumn: GridColDef = {
    field: 'parentDeviceType',
    headerName: 'Parent Device Type',
    width: 150,
    flex: 1,
    filterOperators: stringFilterOperator.operators,
  };

  const parentDeviceIDColumn: GridColDef = {
    field: 'parentDeviceId',
    headerName: 'Parent Device ID',
    width: 150,
    flex: 1,
    filterOperators: stringFilterOperator.operators,
  };

  const deviceTypeColumn: GridColDef = {
    field: 'deviceType',
    headerName: 'Device Type',
    width: 150,
    flex: 1,
    filterOperators: stringFilterOperator.operators,
  };

  const deviceIDColumn: GridColDef = {
    field: 'deviceId',
    headerName: 'Device ID',
    width: 150,
    flex: 1,
    filterOperators: stringFilterOperator.operators,
  };

  const pointNameColumn: GridColDef = {
    field: 'pointName',
    headerName: 'Point Name',
    width: 150,
    flex: 1,
    filterOperators: stringFilterOperator.operators,
  };

  const dataTypeColumn: GridColDef = {
    field: 'dataType',
    headerName: 'Data Type',
    width: 100,
    flex: 1,
    filterOperators: stringFilterOperator.operators,
  };

  const isParsedColumn: GridColDef = {
    field: 'isParsed',
    headerName: 'Is Parsed',
    width: 100,
    flex: 1,
    type: 'boolean',
  };

  ArchiveGridColumns.push(
    idColumn,
    topicColumn,
    siteIDColumn,
    parentDeviceTypeColumn,
    parentDeviceIDColumn,
    deviceTypeColumn,
    deviceIDColumn,
    pointNameColumn,
    dataTypeColumn,
    isParsedColumn,
  );

  return ArchiveGridColumns;
}
